import { createReducer, on } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { setSavedHypotheticalId } from './saved-hypothetical-id.actions';
export const savedHypotheticalId = createReducer(null, on(setSavedHypotheticalId, (state, action) => {
    return action.savedHypotheticalId;
}), on(resetAllCustomPdfReportItems, () => {
    return null;
}));
